import {Component, inject, OnInit} from '@angular/core';
import {
    HealthChartConfiguration, HealthChartPeriod,
    HealthDataType,
} from '../../../../../../models/health.models';
import {NavigationService} from '../../../../../../services/navigation.service';
import {HealthDataPageComponent} from '../../../../../../components/health-data-page/health-data-page.component';
import {dataType} from "terra-api/lib/esm/API/Data";

@Component({
    selector: 'app-blood-glucose-page',
    standalone: true,
    imports: [HealthDataPageComponent],
    templateUrl: './blood-glucose-page.component.html',
    styleUrl: './blood-glucose-page.component.css',
})
export default class BloodGlucosePageComponent implements OnInit {
    #navigationService = inject(NavigationService);

    healthDataLabel = 'Glicemia';
    chartLabel = 'Glicemia';
    chartConfiguration: HealthChartConfiguration = {
        [HealthChartPeriod.day]: 'bubble',
        [HealthChartPeriod.week]: 'bar',
        [HealthChartPeriod.month]: 'bar',
    }
    heightHealthDataType = HealthDataType.BLOOD_GLUCOSE;
    hasTwoDecimals = false;
    payloadTypes: dataType[] = ['body'];

    ngOnInit(): void {
        this.#navigationService.saveCurrentRoute();
    }
}
